import getConfig from 'next/config'

const { CDN_URL } = getConfig().publicRuntimeConfig

export default function createSeoConfig(description, url) {
  return {
    description,
    openGraph: {
      description,
      url,
      images: [
        {
          url: `${CDN_URL}/static/images/share-cover.png`,
          width: 1200,
          height: 630,
          alt: 'TicketSwap',
        },
      ],
      type: 'website',
    },
    twitter: {
      handle: '@TicketSwap',
      site: '@TicketSwap',
      cardType: 'summary_large_image',
    },
  }
}
